'use strict';

exports.__esModule = true;
exports.default = {
    APPWISE: 'appwise',
    APPINSIGHTS: 'appinsights'
};